var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata"},[_c('img',{attrs:{"src":require("@/assets/images/meemo_air.png")}}),_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.$t('h5_no_data')))])])}
var staticRenderFns = []

export { render, staticRenderFns }